<template>
	<r-panel-container :title="`${isNewOrEdition} tema`"
	                   icon="fal fa-books"
	                   :breadcrumb="breadcrumb">
		<template #toolbar>
			<button @click.prevent="guardar"
			        class="btn btn-dark btn-sm"
			        :disabled="disableSaveButton">
				<template v-if="!guardando">
					<i class="fa fa-save"></i>
					Guardar
				</template>
				<template v-else>
					<i class="fa fa-sync fa-spin"></i>
					Guardando
				</template>
			</button>
		</template>
		<template #body>
			<div class="row">
				<div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 pt-3">
					<div class="mb-4">
						<r-input v-model="formularioTema.info.nombre"
						         style-fill
						         :disabled="cargando || guardando"
						         placeholder="Nombre"/>
						<small class="text-danger" v-html="formularioTema.errores.nombre"/>
					</div>
				</div>
			</div>
		</template>
	</r-panel-container>
</template>
<script setup lang="ts">
import {useNotify} from "base-app/dist/composable";
import {clearErrors, equals, showErrors} from "base-app/dist/utils";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import {IFormulario} from "../../interfaces/IFormulario.ts";
import {Temas} from "../../api/Temas.ts";
import {ITema} from "../../interfaces/ITema.ts";
import {RInput, RPanelContainer} from "base-app/dist/components";

const breadcrumb = computed(() => ([
	{title: 'Temas', name: 'temas'},
	{title: isNewOrEdition.value + ' tema'},
]));

const notify = useNotify();
const router = useRouter();
const route = useRoute();


const cargando = ref<boolean>(false);
const guardando = ref<boolean>(false);

const ultimosDatosFormulario = ref<ITema>({
	nombre: '',
});
const formularioTema = ref<IFormulario<ITema>>({
	info: {
		nombre: '',
	},
	errores: {
		nombre: [],
	}
});

onMounted(async () => {
	await cargarTema();
});

const cargarTema = async () => {
	if (route.params.id) {
		cargando.value = true;
		try {
			const {data} = await Temas.porId(route.params.id as string);
			if (data.estado) {
				formularioTema.value.info.nombre = data.info.nombre;
				ultimosDatosFormulario.value = JSON.parse(JSON.stringify(formularioTema.value.info));
			} else {
				notify.error('!Oops!, ocurrio un error, ponte en contacto con el administrador del sistema.');
				volverAtras();
			}
		} catch {
			notify.error('!Oops!, ocurrio un error, ponte en contacto con el administrador del sistema.');
			volverAtras();
		} finally {
			cargando.value = false;
		}
	}
};

const guardar = async () => {
	guardando.value = true;
	clearErrors(formularioTema.value.errores);
	try {
		let data;
		if (route.params.id) {
			formularioTema.value.info.id = route.params.id as string;
			const resultado = await Temas.actualizar(formularioTema.value.info);
			data = resultado.data;
		} else {
			const resultado = await Temas.nuevo(formularioTema.value.info);
			data = resultado.data;
		}
		if (data.estado) {
			notify.success('Datos guardados con exito');
			volverAtras();
		} else {
			showErrors(data.mensajes, formularioTema.value.errores);
		}
	} catch {
		notify.error('Error al intentar guardar');
		volverAtras();
	} finally {
		guardando.value = false;
	}
}
const volverAtras = () => {
	router.push({
		name: 'temas',
	});
};

const disableSaveButton = computed(() => {
	return guardando.value === true || equals(ultimosDatosFormulario.value, formularioTema.value.info);
});

const isNewOrEdition = computed(() => {
	return route.params.id ? 'Editar' : 'Nuevo';
});
</script>